export default __webpack_public_path__ + "static/media/phase-converter.aa27972c.png";